import dynamic from "next/dynamic";
import styleSub from "../../../../styles/Subpage.module.scss";
import cellPlugins from "../../../../components/plugins/cellPlugins";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import useSWR from "swr";
import { fetcher, staticPath } from "../../../../utils";
import { Col, Container, Row } from "react-bootstrap";
import NotificationPopup from "../../../../components/popup/NotificationPopup";
import PageLayout from "../../../../components/layout/PageLayout";

const Editor = dynamic(() => import("@react-page/editor"), {
  ssr: false,
});

const Seo = dynamic(() => import("../../../../components/seo/Seo"), {
  ssr: false,
});

const SubTitle = dynamic(
  () => import("../../../../components/title/SubTitle"),
  {
    ssr: false,
  }
);
const Error = dynamic(() => import("../../../../components/error/Error"), {
  ssr: false,
});

const Page = (props) => {
  const { t } = useTranslation();
  const { asPath, locale } = useRouter();
  const [main, setMain] = useState();
  const [mainUrl, setMainUrl] = useState();
  const [metaDescription, setMetaDescription] = useState();
  const [title, setTitle] = useState();
  const [slug, setSlug] = useState();
  const [isActive, setIsActive] = useState(false);
  const [isActiveIsteSantral, setIsActiveIsteSantral] = useState(false);
  const {
    pageName,
    pageRoute,
    data,
    errorCode,
    navbar,
    footer,
    navbarData,
    navbarFooterData,
  } = props;
  const { data: menu } = useSWR("menu", fetcher);
  const router = useRouter();
 
  useEffect(() => {
    if (router.query.page === "gpu-as-a-service") {
      setMetaDescription(
        "İşNet'in TIER4 veri merkezinden sunulan GPUaaS hizmeti ile yapay zeka, büyük veri ve grafik işleme projelerinizi güvenli ve esnek altyapıyla yönetin."
      );
      setTitle(`Yüksek Performanslı GPU Hizmeti | İşNet`)
    }
    else{
      setMetaDescription(
        `Dijital dönüşüm dostu İşNet'in ${pageName} hizmeti hakkında bilgi almak için sayfamızı inceleyin. Daha fazla bilgi için başvuru formunu doldurarak İşNet'in ${pageName} hizmeti ile tanışın.`
      );
      setTitle(`${pageName} Hizmeti | İşNet`)
    }

    const mainRoute = menu?.find(
      (item) => item.href === router?.query?.main
    )?.name;

    const mainRouteUrl = menu?.find(
      (item) => item.href === router?.query?.main
    )?.href;
    setMainUrl(mainRouteUrl);
    const slugRoute = menu?.find(
      (item) => item.href === router.query.slug
    )?.name;
    setMain(mainRoute);
    setSlug(slugRoute);
    if (router.query.page === "ka-band-konnect") {
      setIsActive(true);
    }
    if (router.query.page === "istesantral-bulutsantral") {
      setIsActiveIsteSantral(true);
    }
  }, [menu, router]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      dataLayer.push(arguments);
    };
    window.gtag("js", new Date());

    window.gtag("event", "view_item", {
      currency: "TRY",
      value: 7.77,
      items: [
        {
          item_id: "SKU_12345",
          item_name: `${pageName}`,
          coupon: "SUMMER_FUN",
          index: 0,
          item_brand: "Google",
          item_category: "Apparel",
          price: 9.99,
          quantity: 1,
        },
      ],
    });
  }, []);
  if (errorCode) {
    return (
      <Error
        statusCode={errorCode}
        notFoundSentence={t("home:not_found")}
        home={t("home:go_to_home")}
      />
    );
  }
  return (
    <PageLayout
      navbarData={navbarData}
      navbar={navbar}
      footer={footer}
      navbarFooterData={navbarFooterData}
    >
      <section>
        <SubTitle
          className="section_header_page_blog"
          TitleText={pageName}
          pageName={pageName}
          pageRoute={pageRoute}
          mainPage={main ? main : null}
          mainPageName={slug}
          imgUrl={
            data.picture
              ? data.picture?.type + ";base64," + data.picture?.src
              : "/logo.svg"
          }
        />
        <Seo
          title={title}
          keywords={pageName}
          description={metaDescription}
          url={locale === "tr" ? asPath : "/en" + asPath}
          img={
            data.picture
              ? data?.picture?.type + ";base64," + data?.picture?.src
              : "/logo.svg"
          }
          script={`gtag("event", "view_item", {
      currency: "TRY",
      value: 7.77,
      items: [
        {
          item_id: "SKU_12345",
          item_name: "${pageName}",
          coupon: "SUMMER_FUN",
          index: 0,
          item_brand: "${pageName}",
          item_category: "${main}",
          location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
          price: 9.99,
          quantity: 1,
        },
      ],
    })`}
        />

        {pageRoute === "/internet/adsl-vdsl" && <NotificationPopup />}
        <div className={styleSub.sub_page}>
          <Container>
            <Editor
              value={JSON.parse(data.content)}
              cellPlugins={cellPlugins}
              readOnly
            />
            {isActive ? (
              <Container>
                <Row>
                  <Col md={6} className="p-0">
                    <div className="box box-satelite">
                      <div className="box-title">
                        <h1>BİREYSEL PAKETLER</h1>
                      </div>
                      <div className="box-body">
                        <Container>
                          <Row>
                            <Col md={6}>
                              <div className="card card-satelite">
                                <div
                                  className="card-top"
                                  style={{
                                    backgroundImage: `url(
                                    "/img/uydu/uzay.png"
                                  )`,
                                    backgroundPosition: "bottom center",
                                  }}
                                >
                                  <div className="card-title">
                                    <h2>Temel</h2>
                                  </div>
                                  <div className="card-desc">
                                    <p>
                                      25 Mbps'e kadar Download
                                      <br /> 6 Mbps'e kadar Upload
                                    </p>
                                  </div>
                                  <div className="card-sub">
                                    <p>10 GB Kota</p>
                                  </div>
                                </div>
                                <div className="card-bottom">
                                  <div className="card-price">
                                    <div className="card-money">
                                      <span>€</span>
                                      <h1>30</h1>
                                    </div>
                                    <p>Aylık</p>
                                    <span>(Vergiler Dahil)</span>
                                  </div>
                                  <div className="card-footer">
                                    <a
                                      href="/iletisim/urunbasvuruformu?product=3af40c8f-a751-4026-b768-08dac9693010&title=Bireysel Temel 10 GB Kota"
                                      className="btn btn-app"
                                    >
                                      Hemen Başvur
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="card card-satelite">
                                <div
                                  className="card-top"
                                  style={{
                                    backgroundImage: `url(
                                    "/img/uydu/uzay.png"
                                  )`,
                                    backgroundPosition: "bottom center",
                                  }}
                                >
                                  <div className="card-title">
                                    <h2>Standart</h2>
                                  </div>
                                  <div className="card-desc">
                                    <p>
                                      50 Mbps’e kadar Download
                                      <br /> 6 Mbps’e kadar Upload
                                    </p>
                                  </div>
                                  <div className="card-sub">
                                    <p>60 GB Kota</p>
                                  </div>
                                </div>
                                <div className="card-bottom">
                                  <div className="card-price">
                                    <div className="card-money">
                                      <span>€</span>
                                      <h1>110</h1>
                                    </div>
                                    <p>Aylık</p>
                                    <span>(Vergiler Dahil)</span>
                                  </div>
                                  <div className="card-footer">
                                    <a
                                      href="/iletisim/urunbasvuruformu?product=3af40c8f-a751-4026-b768-08dac9693010&title=Bireysel Standart10 GB Kota"
                                      className="btn btn-app"
                                    >
                                      Hemen Başvur
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col md={12}>
                              <p className="text-satelite">
                                Tüm paketlerde gece 01.00 - 06.00 saatleri
                                arasında kullanım kotayı tüketmez.
                              </p>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="p-0">
                    <div className="box box-satelite gray-200">
                      <div className="box-title">
                        <h1>KURUMSAL PAKETLER</h1>
                      </div>
                      <div className="box-body">
                        <Container>
                          <Row>
                            <Col md={6}>
                              <div className="card card-satelite">
                                <div
                                  className="card-top"
                                  style={{
                                    backgroundImage: `url(
                                    "/img/uydu/uzay.png"
                                  )`,
                                    backgroundPosition: "bottom center",
                                  }}
                                >
                                  <div className="card-title">
                                    <h2>Profesyonel</h2>
                                  </div>
                                  <div className="card-desc">
                                    <p>
                                      25 Mbps’e kadar Download
                                      <br /> 6 Mbps’e kadar Upload
                                    </p>
                                  </div>
                                  <div className="card-sub">
                                    <p>10 GB Kota</p>
                                  </div>
                                </div>
                                <div className="card-bottom">
                                  <div className="card-price">
                                    <div className="card-money">
                                      <span>€</span>
                                      <h1>55</h1>
                                    </div>
                                    <p>Aylık</p>
                                    <span>(Vergiler Dahil)</span>
                                  </div>
                                  <div className="card-footer">
                                    <a
                                      href="/iletisim/urunbasvuruformu?product=3af40c8f-a751-4026-b768-08dac9693010&title=Kurumsal Profesyonel 10 GB Kota"
                                      className="btn btn-app"
                                    >
                                      Hemen Başvur
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="card card-satelite card-popular">
                                <span className="popular">Popüler Seçenek</span>
                                <div
                                  className="card-top"
                                  style={{
                                    backgroundImage: `url(
                                    "/img/uydu/uzay.png"
                                  )`,
                                    backgroundPosition: "bottom center",
                                  }}
                                >
                                  <div className="card-title">
                                    <h2>Premium</h2>
                                  </div>
                                  <div className="card-desc">
                                    <p>
                                      50 Mbps’e kadar Download <br /> 10 Mbps’e
                                      kadar Upload
                                    </p>
                                  </div>
                                  <div className="card-sub">
                                    <p>25 GB Kota</p>
                                  </div>
                                </div>
                                <div className="card-bottom">
                                  <div className="card-price">
                                    <div className="card-money">
                                      <span>€</span>
                                      <h1>92</h1>
                                    </div>
                                    <p>Aylık</p>
                                    <span>(Vergiler Dahil)</span>
                                  </div>
                                  <div className="card-footer">
                                    <a
                                      href="/iletisim/urunbasvuruformu?product=3af40c8f-a751-4026-b768-08dac9693010&title=Kurumsal Premium 25 GB Kota"
                                      className="btn btn-app"
                                    >
                                      Hemen Başvur
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col md={12}>
                              <p className="text-satelite">
                                Tüm paketlerde gece 01.00 - 06.00 saatleri
                                arasında kullanım kotayı tüketmez. Kurumsal
                                paket trafikleri bireysel pakete göre iş
                                sürekliliği sağlamak amacıyla önceliklendirilir.
                              </p>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            ) : null}
          </Container>
        </div>
      </section>
    </PageLayout>
  );
};

export async function getServerSideProps(context) {
  let { slug, page } = context.query;
  const [data, navbarData, navbarFooterData, footerData] = await Promise.all([
    fetch(`${process.env.ISNETURL}/page/${slug}/${page}`).then((res) =>
      res.json()
    ),
    fetch(`${process.env.ISNETURL}/menu`).then((res) => res.json()),
    fetch(`${process.env.ISNETURL}/menu/footermenu`).then((res) => res.json()),
    fetch(`${process.env.API_URL}/footer`).then((res) => res.json()),
  ]);

  const navbarFilter =
    navbarData && navbarData?.filter((item) => item.isDeleted === false);

  let navbar, footer;
  if (navbarFilter || footerData) {
    const nav = staticPath(navbarFilter);
    navbar = nav;
    footer = footerData;
  }

  context.res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [
        "home",
        "forms",
        "preApplication",
      ])),
      pageName: data ? data.title : null,
      pageRoute: `/${slug}/${page}`,
      data: data ? data : null,
      navbar,
      footer,
      navbarData,
      navbarFooterData,
    },
  };
}

export default Page;
